import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Minimal as MinimalLayout } from '../../../layouts';
import '../../../assets/scss/entrar.scss';
import configBase from '../../../configBase';
import axios from 'axios';

import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';



class Entrar extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      email: '',
      password: '',
      errorFormat: '',

      loading: false,
      snackError: false,
      snackMsg: '',
    };

    this.errorField = {
      email: '',
      password: ''
    };

    this.errorFormat = {
      email: ''
    };

    this.styles = {
      
    }

  }


  componentDidMount() {
    // Quando já estiver logado
    if (window.localStorage.getItem('planos_t') != null ||
    window.localStorage.getItem('planos_u') != null ||
    window.localStorage.getItem('planos_y') != null ||
    window.localStorage.getItem('planos_n') != null ||
    window.localStorage.getItem('planos_i') != null) {

      this.props.history.push(`${process.env.PUBLIC_URL}/`);
    }
  }

  onChange(e) {
    let state = this.state;
    state[e.target.name] = e.target.value;

    if (e.target.type === 'email')
      this.onBlurField(e);

    if (e.target.value === '')
      this.errorField[e.target.name] = 'Campo obrigatório';
    else
      this.errorField[e.target.name] = '';

    this.setState(state);
  }

  // Valida campos de e-mail
  onBlurField(e) {
    let state = this.state;

    // Se o campo for do tipo email
    if (e.target.type === 'email') {
      // Se o conteúdo não for válido
      if (e.target.value.length === 0 || !e.target.validity.valid)
        this.errorFormat.email = 'Email inválido: email@exemplo.com';
      // Se o conteúdo for válido, retira mensagem de erro
      else
        this.errorFormat.email = '';
    }

    this.setState(state);
  }

  // Valida campos em branco (form login)
  validationFields() {
    let fields = ['email', 'password'];
    let message = 'Campo obrigatório';

    for (let i = 0; i < fields.length; i++) {
      if (this.state[fields[i]] === '') {
        this.errorFormat[fields[i]] = message;
        this.setState(this.state);
        return false;
      }
      else
        this.errorFormat[fields[i]] = '';
    }
    this.setState(this.state);
    return true;
  }

  onSubmitForm(e) {
    e.preventDefault(e);
    let state = this.state;
    state.loading = true;

    if (this.validationFields()) {
      let fields = {
        email: this.state.email,
        password: this.state.password
      };

      axios.post(configBase.api + 'Accounts/login?include=USER', fields)
      .then((result) => {
        // Seta access_token
        window.localStorage.setItem('planos_t', result.data.id);
        // Seta id do usuário
        window.localStorage.setItem('planos_u', result.data.userId);
        // Seta type de conta do usuário
        window.localStorage.setItem('planos_y', result.data.user.type);
        // Seta nome do usuário
        window.localStorage.setItem('planos_n', result.data.user.name);
        // Seta imagem do usuário
        window.localStorage.setItem('planos_i', result.data.user.image);

        this.props.history.push(`${process.env.PUBLIC_URL}/`);
      })
      .catch(function (erro) {
        let state = this.state;

        if (erro.response) {
          state.loading = false;
          state.snackError = true;
          state.snackMsg = 'Email e senha não encontrados';
        }
        else {
          state.loading = false;
          state.snackError = true;
          state.snackMsg = 'Problemas no servidor. Tente novamente mais tarde.';
        }

        this.setState(state);
      }.bind(this));
    }

    this.setState(state);
  }

  handleClose() {
    let state = this.state;
    state.snackError = false;
    this.setState(state);
  }

  render() {

    return (
      <MinimalLayout>
        <div className={{flexGrow: 1}}>
          <Grid container spacing={0}>
            <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>

            <Grid item xs={12} sm={12} md={3} lg={3}>
              <Paper
                id="bgLoginMobile"
                className="paper"
                style={{backgroundImage: `url(${process.env.PUBLIC_URL}/images/bg_login_mobile.jpg)`}}
              >
                <div style={{textAlign: 'center'}}>
                  <img id="logoLogin" alt="logo" src={`${process.env.PUBLIC_URL}/images/logo.png`} />
                </div>

                <Typography
                  id="tituloLogin"
                  variant="h3"
                >
                  Painel Administrativo
                </Typography>

                <Typography
                  color="textSecondary"
                  gutterBottom
                >
                  PLANOS {configBase.empresaMaiuscula}
                </Typography>

                <form onSubmit={this.onSubmitForm.bind(this)}>
                  <div id="emailLogin">
                    <TextField
                      error={this.errorFormat.email ? true : false}
                      fullWidth
                      helperText={this.errorFormat.email}
                      label="E-mail"
                      name="email"
                      onChange={this.onChange.bind(this)}
                      onBlur={this.onBlurField.bind(this)}
                      type="email"
                      value={this.state.email}
                      variant="outlined"
                      size="small"
                    />
                  </div>

                  <div id="senhaLogin">
                    <TextField
                      error={this.errorFormat.password ? true : false}
                      fullWidth
                      helperText={this.errorFormat.password}
                      label="Senha"
                      name="password"
                      onChange={this.onChange.bind(this)}
                      onBlur={this.onBlurField.bind(this)}
                      type="password"
                      value={this.state.password}
                      variant="outlined"
                      size="small"
                    />
                  </div>

                  <div id="botaoLogin" className="containerButton">
                    <Button
                      disabled={this.state.loading}
                      style={{backgroundColor: configBase.corPrincipal, color: configBase.corSecundaria}}
                      color="primary"
                      fullWidth
                      size="medium"
                      type="submit"
                      variant="contained"
                      onClick={this.onSubmitForm.bind(this)}
                    >
                      LOGIN
                    </Button>

                    {
                      this.state.loading === true ? (
                    <CircularProgress size={24} className="progressButton" />
                      ) : ('')
                    }

                  </div>
                </form>
              </Paper>
            </Grid>

            <Grid item xs={12} sm={12} md={3} lg={3}>
              <div
                id="bgLogin"
                style={{backgroundImage: `url(${process.env.PUBLIC_URL}/images/bg_login.jpg)`}}
              >
                {''}
              </div>
            </Grid>

            <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
          </Grid>

          <Snackbar open={this.state.snackError} autoHideDuration={5000} onClose={this.handleClose.bind(this)}>
            <MuiAlert className="snackbarStyle" onClose={this.handleClose.bind(this)} severity="error" variant="filled" elevation={6}>
              {this.state.snackMsg}
            </MuiAlert>
          </Snackbar>
        </div>
      </MinimalLayout>
    );

  }

}

Entrar.propTypes = {
  history: PropTypes.object
};

export default withRouter(Entrar);